// extracted by mini-css-extract-plugin
module.exports = {"worktitle":"Work_worktitle__LgRek","leftproject":"Work_leftproject__3I9Be","picture":"Work_picture__kpDV_","rightproject":"Work_rightproject__2mtSj"};